import styled, { css } from 'styled-components';
import { StatusInformativeNotificationType } from '../ThemeProvider/types';

export const Container = styled.div<{
  status: StatusInformativeNotificationType;
  isMobile: boolean;
  width: number;
  clickable: boolean;
}>`
  border: 1px solid;
  border-radius: 10px;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  ${({ status, theme, isMobile }) => css`
    padding: ${isMobile ? 16 : 24}px;
    background: ${`${theme.informationNotification[status].background}`};
    border-color: ${`${theme.informationNotification[status].border}`};
  `}
      cursor: ${({ clickable }) => (clickable ? 'pointer' : 'normal')}
`;

export const NotificationTitle = styled.div<{
  isMobile: boolean;
}>`
  font-family: 'Mulish', sans-serif;
  font-weight: 700;
  margin-bottom: 4px;
  display: flex;
  column-gap: 8px;
  font-style: normal;
  justify-content: space-between;

  & > div:nth-child(2) {
    flex: 1;
    text-align: left;
  }

  ${({ isMobile }) => css`
    line-height: ${isMobile ? 17 : 20}px;
    font-size: ${isMobile ? 14 : 16}px;
  `}
`;

export const NotificationBody = styled.div`
  font-family: 'Mulish', sans-serif;
  padding-left: 28px;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  white-space: pre-line;
  line-height: 17px;
`;
